/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021

!Changelog

2021
	25-03-2021
	- Changed the functions
2017
	23-03-2017
	- [BUILD] First build

!Usage

	loader.change(option); 0 = off, 1 is on
	
!Wishlist

	none
 
*/

var notifier = {};

(function(){
	
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none

	// FUNCTIONS *****************************************************************
	// FUNCTIONS *****************************************************************
	// FUNCTIONS *****************************************************************
	// FUNCTIONS *****************************************************************

	/*
	Show
	*/
	this.show = function (
		message
	) {
		
		$('.js-notifier').find('.notifier-message').html(message);

		$('.js-notifier').fadeIn();

		/*
		Hide automatically
		*/
		setTimeout(function() {
			notifier.hide();
		},1500);
		
	};

	/*
	Hide
	*/
	this.hide = function() {
		$('.js-notifier').fadeOut();
	};
		
}).apply(notifier); 